import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';
import { formatDisplayValue } from '../../../lib/styles/perttierNumber';

/* Single Input 컴포넌트 */
export const Input = ({
    label,
    variable,
    variableName,
    unit,
    value,
    min = '0',
    referenceValue,
    onChange,
    isRequired,
    isText = false,
    ...props
}) => {
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                <StyledInput
                    name={variableName}
                    value={value}
                    onChange={(e) => {
                        if (isText) {
                            onChange(e);
                        } else {
                            const newValue = e.target.value;
                            // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                            if (newValue === '' || Number(newValue) >= Number(min)) {
                                onChange(e);
                            }
                        }
                    }}
                    placeholder={referenceValue ?? ''}
                    {...props}
                />
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* Single Output 컴포넌트 */
export const Output = ({ label, variable, unit, value, isSub, isSafe=true }) => {
    return (
        <OutputWrapper isSub={isSub}>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                <StyledOutput value={formatDisplayValue(value)} disabled isSub={isSub} isSafe={isSafe} />
            </InputBlock>
            <Unit>{unit}</Unit>
        </OutputWrapper>
    );
};

/* Single Select 컴포넌트 */
export const Select = ({ label, variable, variableName, unit, value, options, onChange, isRequired }) => {
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                <StyledSelect name={variableName} value={value} onChange={onChange} isRequired={isRequired}>
                    <option value="" selected disabled hidden>
                        Select...
                    </option>
                    {options.map((item, index) => (
                        <option key={index} value={item.value}>
                            {item.text}
                        </option>
                    ))}
                </StyledSelect>
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* Error Message */
export const ErrorMessage = ({ label, variable, unit, value }) => {
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                <Error value={formatDisplayValue(value)} disabled />
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

/* ----------------  Styled Components ----------------- */
export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.25rem 1rem;
    transition: background-color 0.3s ease;
    border-radius: 5px;
    &:hover {
        background-color: ${palette.gray[1]};
    }
`;

export const Label = styled.div`
    flex: 1;
    overflow: hidden;
`;

export const Variable = styled.div`
    margin-right: 1rem;
    text-align: right;
    font-size: 0.9rem;
    color: ${palette.gray[6]};
`;

export const InputBlock = styled.div`
    display: flex;
    gap: 1rem;
`;

export const StyledInput = styled.input`
    width: 100px;
    // box-sizing: boder-box;
    border: none;
    outline: none;
    background-color: ${palette.cyan[0]};
    text-align: right;
    padding: 0.25rem 0;
    padding-right: 0.5rem;
    font-size: 0.95rem;

    &::placeholder {
        color: ${palette.lime[5]};
        font-style: italic;
    }

    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

export const OutputWrapper = styled(Wrapper)`
    
    ${(props) => 
        props.isSub &&
        css`
            padding-left: 2rem;
            color: ${palette.gray[6]};
            font-size: 0.9rem;
        `
    }
`;
export const StyledOutput = styled(StyledInput)`
    background-color: transparent;

    ${(props) => 
        props.isSub &&
        css`
            color: ${palette.gray[6]};
            font-size: 0.9rem;
        `
    }

    ${(props) => 
        !props.isSafe &&
        css`
            color: red;
        `
    }

`;

export const StyledSelect = styled.select`
    width: 100px;
    border: none;
    outline: none;
    background-color: ${palette.cyan[0]};
    text-align: center;
    padding: 0.25rem 0;
`;

export const Unit = styled.div`
    width: 60px;
    margin-left: 1rem;
    overflow: hidden;
    font-size: 0.9rem;
    color: ${palette.gray[6]};
`;

const Error = styled(StyledOutput)`
    color: red;
`;
